module.exports = __webpack_public_path__ + "img/japan.78e4ccfc.jpg";